<template>
  <div class="target-calculator">
    <div class="row">
      <div class="col-lg-12">
        <div class="card target-border">
          <div class="card-body">
            <v-form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-md-6">
                  <div class="target-input">
                    <label for="target-amount" class="label-spacing"
                      >Target amount</label
                    >
                    <span class="target-group">
                      <div class="rupees-symbol">₹</div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formData.targetAmount"
                        outlined
                        id="target-amount"
                        style="
                          text-align: justify;
                          border-color: #ced4da;
                          border: none !important;
                          outline: none !important;
                          box-shadow: none !important;
                        "
                      />
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="target-input">
                    <label for="existing-investment" class="label-spacing"
                      >Existing investment</label
                    >
                    <span class="target-group">
                      <div class="rupees-symbol">₹</div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formData.existingInvestment"
                        outlined
                        id="existing-investment"
                        style="
                          text-align: justify;
                          border-color: #ced4da;
                          border: none !important;
                          outline: none !important;
                          box-shadow: none !important;
                        "
                      />
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="target-input">
                    <label for="years-to-target" class="label-spacing"
                      >Number of years to target</label
                    >
                    <span class="target-group">
                      <button type="button" @click="decreaseTimePeriod">
                        -
                      </button>
                      <input
                        type="text"
                        v-model="formData.yearsToTarget"
                        class="form-control text-center"
                        outlined
                        id="years-to-target"
                        style="border: none; outline-width: 0"
                      />
                      <button type="button" @click="increaseTimePeriod">
                        +
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="target-input">
                    <label for="expected-returns" class="label-spacing"
                      >Expected returns from investments</label
                    >
                    <span class="target-group">
                      <button type="button" @click="decreaseReturns">-</button>
                      <input
                        style="border: none; outline-width: 0"
                        class="form-control text-center"
                        type="text"
                        v-model="formData.expectedReturns"
                        outlined
                        id="expected-returns"
                      />
                      <button type="button" @click="increaseReturns">+</button>
                    </span>
                  </div>
                </div>
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <button type="submit" class="target-button">Calculate</button>
                </div>
              </div>
            </v-form>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="second-card">
          <div class="row">
            <div class="col-md-4">
              <div class="card target-border-card">
                <div class="card-body target-card-color">
                  <div class="text-center">
                    <label for="total-investment" class="target-card-label"
                      >Target <br />investment</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="formattedTargetInvestment"
                      class="target-card-input"
                      id="total-investment"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card target-border-card">
                <div class="card-body target-card-color">
                  <div class="text-center">
                    <label for="time-returns" class="target-card-label"
                      >Future value of <br />existing investment</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="formattedExistingReturns"
                      class="target-card-input"
                      id="time-returns"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card target-border-card">
                <div class="card-body positiveresult">
                  <div class="text-center">
                    <label style="font-weight: bold" for="total-returns"
                      >Monthly investment <br />needed</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="formattedMonthlyInvestment"
                      id="total-returns"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <i class="target-disclaim"
              >Disclaimer: Results shown for illustrative purpose only and
              should not be construed as investment advice</i
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TargetCalculator",
  data() {
    return {
      formData: {
        targetAmount: 200000,
        existingInvestment: 100000,
        yearsToTarget: "3 Years",
        expectedReturns: "12 %",
        minValue: 0,
        maxValue: 100,
      },
      monthlyInvestment: "2,155",
      totalDifference: "1,15,763",
      totalTarget: "2,00,000",
    };
  },
  computed: {
    formattedTargetInvestment() {
      return `₹ ${this.totalTarget.toLocaleString("en-IN")}`;
    },
    formattedExistingReturns() {
      return `₹ ${this.totalDifference.toLocaleString("en-IN")}`;
    },
    formattedMonthlyInvestment() {
      return `₹ ${this.monthlyInvestment.toLocaleString("en-IN")}`;
    },
  },
  methods: {
    submitForm() {
      this.calculateTotalValue();
    },
    increaseReturns() {
      const numericValue = parseFloat(this.formData.expectedReturns);
      if (numericValue > 3) {
        this.formData.expectedReturns = `${Math.min(numericValue + 0.5, 20)} %`;
      }
    },
    decreaseReturns() {
      const numericValue = parseFloat(this.formData.expectedReturns);
      if (numericValue <= 20.5) {
        this.formData.expectedReturns = `${Math.max(
          numericValue - 0.5,
          3.5
        )} %`;
      }
    },
    calculateTotalValue() {
      const targetAmount = parseFloat(this.formData.targetAmount);
      const existingInvestment =
        parseFloat(this.formData.existingInvestment) || 0;
      const yearsToTarget = parseFloat(this.formData.yearsToTarget);
      const expectedReturns = parseFloat(this.formData.expectedReturns) / 100;
      const monthlyInterestRate = expectedReturns / 12;
      const months = yearsToTarget * 12;
      const futureValueExisting =
        existingInvestment * Math.pow(1 + monthlyInterestRate, months) || 0;
      const totalAmountNeeded = targetAmount - futureValueExisting;
      const futureValue =
        Math.round(
          existingInvestment * Math.pow(1 + expectedReturns, yearsToTarget)
        ) || 0;
      const monthlyInvestment =
        totalAmountNeeded /
        (((Math.pow(1 + monthlyInterestRate, months) - 1) /
          monthlyInterestRate) *
          (1 + monthlyInterestRate));
      this.monthlyInvestment = Math.round(monthlyInvestment);
      this.totalDifference = futureValue.toLocaleString("en-IN");
      this.totalTarget = targetAmount;
    },
    increaseTimePeriod() {
      const numericValue = parseInt(this.formData.yearsToTarget);
      if (numericValue < 50) {
        this.formData.yearsToTarget = `${numericValue + 1} Years`;
      }
    },
    decreaseTimePeriod() {
      const numericValue = parseInt(this.formData.yearsToTarget);
      if (numericValue > 1) {
        this.formData.yearsToTarget = `${numericValue - 1} Years`;
      }
    },
  },
};
</script>

<style scoped>
.target-calculator .target-input label {
  display: block;
  font-weight: bold;
  text-align: justify;
  font-size: 16px;
  color: #012e40 !important;
}

.target-input input {
  text-align: justify;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.target-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
}

.target-button {
  width: 100%;
  background-color: #00a3d9;
  color: white;
  margin-top: -32px;
  padding: 0.6em;
  border-radius: 5px;
}

.target-calculator .target-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.label-spacing {
  margin-bottom: 0.7rem;
}

.target-border {
  border: none;
  outline: none;
  background: none;
  padding: 12px;
}

.target-card input {
  border: none;
  outline: none;
  background: none;
  flex: 1;
  text-align: right;
}

.target-border-card {
  border: none;
}

.target-card-color {
  background: #f8f9fa;
  border-radius: 10px;
}

.target-card-label {
  font-weight: bold;
  text-align: center;
}

.target-card-input {
  text-align: center;
  border: none;
  outline: none;
  background: transparent;
}

.target-calculator .target-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.target-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.second-card {
  border: none !important;
  padding: inherit;
  display: flex;
  margin-top: -3%;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 13px;
}

.target-disclaim {
  color: #918d99;
  font-size: 14px;
}

.positiveresult {
  background: rgba(56, 226, 178, 0.2);
  border-radius: 10px;
}
.positivere label {
  font-weight: bold;
  font-size: 16px;
  line-height: 23px;
  color: #012e40;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
.positiveresult input {
  font-weight: bold;
  font-size: 16px;
  line-height: 23px;
  color: #012e40;
  text-shadow: 3px 3px 8px rgba(0, 255, 87, 0.25);
  border: none;
  text-align: center;
  background: none;
}
</style>
